import React from 'react';
import InfoPanel from "./components/info-panel/InfoPanel";
import {BackgroundImage} from "./components/background-image/BackgroundImage";
import styles from './Banner.module.scss';

export const Banner = (props) => {
  return (
    <div className={styles.container}>
      <InfoPanel/>
      <BackgroundImage/>
    </div>
  );
};

Banner.propTypes = {}

Banner.defaultProps = {}

export default React.memo(Banner);